import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

export const itemsContainerCss = css({
  marginTop: 10,
  [MediaQueries.md]: {
    marginTop: 22,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 32,
  },
});

export const itemTextCss = css(typography.effra40, {
  color: 'inherit',
  pointerEvents: 'none',
  fontWeight: fontWeights.light,
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: -2,
    left: 0,
    width: '100%',
    height: 1,
    borderBottom: `1px solid ${colorsPalette.grey90}`,
  },
});

export const activeTextCss = css({
  '&:after': {
    borderBottom: `1px solid ${colorsPalette.grey50}`,
  },
});

export const activeItemCss = css({
  color: colorsPalette.white,
});

export const itemCss = css({
  marginBottom: 16,
  [MediaQueries.md]: {
    marginBottom: 29,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 27,
  },
});

export const buttonCss = css({
  cursor: 'pointer',
  color: colorsPalette.grey50,
  '&:hover': {
    color: colorsPalette.white,
  },
});

export const titleCss = css(typography.effra40, {
  color: colorsPalette.grey40,
  fontWeight: fontWeights.light,
  [MediaQueries.lg]: {
    marginBottom: 24,
  },
  [MediaQueries.xl]: {
    marginBottom: 32,
  },
});

export const descriptionCss = css(typography.effra18, {
  color: colorsPalette.grey20,
  [MediaQueries.lg]: {
    marginBottom: 32,
  },
  [MediaQueries.xl]: {
    marginBottom: 40,
  },
});

export const bottomLinksCss = css({
  alignItems: 'flex-end',
  bottom: 57,
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  right: 0,
  [MediaQueries.md]: {
    bottom: 65,
  },
  [MediaQueries.lg]: {
    textAlign: 'right',
  },
});

export const linkStyleCss = css(typography.effra16, {
  borderBottom: `1px solid ${colorsPalette.transparent}`,
  color: colorsPalette.white,
  textAlign: 'end',
  textDecoration: 'none',
  '&:hover': {
    borderColor: colorsPalette.grey90,
  },
});

export const bottomRightLink1Css = css({
  marginBottom: 8,
});

export const verticalLineCss = css({
  position: 'absolute',
  width: 1,
  height: '100%',
  top: 0,
  left: '36%',
  borderLeft: `1px solid ${colorsPalette.white}`,
  opacity: 0.05,
});
